// Capa 5 financiera (admin-billing-*.md). Constantes de dominio.

// Magnitud de un rubro de costo cuantitativo (whitelist del contrato).
export const MAGNITUDES = [
    { value: 'month', label: 'Mes' },
    { value: 'kg',    label: 'Kg' },
    { value: 'unit',  label: 'Unidad' },
    { value: 'liter', label: 'Litro' },
];

export const magnitudeLabel = (m) => MAGNITUDES.find((x) => x.value === m)?.label || m || '—';

// Estado uniforme del catálogo (soft-delete = 0).
export const BILLING_STATUS_LABEL = { 2: 'Activo', 1: 'Inactivo', 0: 'Eliminado' };
